import React__default from 'react';
import getButtonComponentBySkin from './components/option-skins/index.mjs';

const ButtonOptions = (props) => {
    const onChangeHandler = (event) => {
        props.onChanged(event);
    };
    const ButtonComponent = getButtonComponentBySkin(props.skin ?? "wide");
    const buttonProps = { ...props, onChanged: onChangeHandler };
    return React__default.createElement(ButtonComponent, { ...buttonProps });
};

export { ButtonOptions };
//# sourceMappingURL=button-options.mjs.map
